import * as React from 'react';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import BaggagePriceBlock from '../BaggagePriceBlock/BaggagePriceBlock';
import { getDisabled, getPrice, getSelectedServices, hasUnconfirmedServices } from '../../store/selector';
import { BaggageContext } from '../../../context';
import { getBaggageHasChanges } from '../../utils';
import { SelectedUpgrade } from '../../types';
import { useConfig } from '../../../../context';
import { FooterMobile } from '@shared/ui';

interface Props {
	initialSelectedServices: SelectedUpgrade[];
	onCancel: React.DispatchWithoutAction;
	onConfirm: React.DispatchWithoutAction;
}

const BaggageMobileFooter: React.FC<Props> = ({ onConfirm, onCancel, initialSelectedServices }) => {
	const { BaggageMobileFooter: css } = useTheme('UpgradeBaggageDialog');
	const isReadOnly = useContext(BaggageContext)?.isReadOnly || false;
	const { t } = useTranslation('IncludedBaggage');

	const { dynamicBaggagePricing } = useConfig().global;

	const selectedServices = useSelector(getSelectedServices);
	const disabled = useSelector(getDisabled);
	const price = useSelector(getPrice);
	const unconfirmedServicesExists = useSelector(hasUnconfirmedServices);

	const hasChanges = dynamicBaggagePricing ? true : getBaggageHasChanges(initialSelectedServices, selectedServices);

	const priceBlock = price ? (
		<div className={css.priceRow} data-baggage-price>
			<BaggagePriceBlock price={price} hideClear={isReadOnly || !unconfirmedServicesExists} />
		</div>
	) : null;

	return (
		<FooterMobile
			className={css.wrapper}
			onBack={onCancel}
			onContinue={!isReadOnly ? onConfirm : undefined}
			disabled={!hasChanges || disabled}
			backButtonText={t('Cancel')}
			continueButtonText={t('Confirm')}
			children={priceBlock}
		/>
	);
};

export default BaggageMobileFooter;
